export const ISSUE_SEVERITY_VALUES = ['minor', 'major', 'critical'] as const;

export type IssueSeverity = (typeof ISSUE_SEVERITY_VALUES)[number];

export const ISSUE_SEVERITIES: readonly {
  value: IssueSeverity;
  label: string;
  help: string;
}[] = [
  {
    value: 'minor',
    label: 'Minor',
    help: 'Cosmetic or style. The science is fine.',
  },
  {
    value: 'major',
    label: 'Major',
    help: 'Misleading or hard to use. A reader would need to fix it.',
  },
  {
    value: 'critical',
    label: 'Critical',
    help: 'A wrong scientific claim or wrong number.',
  },
];

export const issueSeverityLabel = (severity: IssueSeverity): string =>
  ISSUE_SEVERITIES.find((entry) => entry.value === severity)?.label ?? severity;
